import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../helpers/history';
import { accountActions } from '../../action/AccountAction';
import { gameActions } from "../../action/GameAction";
import { Helmet } from "react-helmet";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
// import 'bootstrap-daterangepicker/daterangepicker.css';
import { commonClass } from "../../helpers/commonClass";
var CryptoJS = require("crypto-js");

class JackpotWinner extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rdoStatus: 0,
            rdoStatus1: 0,
            rdoStatus2: 0,
            rdoStatus3: 0,
            TransactionData: [],
            serverDate: new Date(),
            rdoStatus4: 0,
            allStatus: 0,
            rdoStatus5: 0,
            rdoStatus6: 0,
            rdoStatus7: 0,
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),

            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: []

        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            OrderData: props.OrderData && props.OrderData.result && props.OrderData.result.map(function (ele) {
                return { ...ele, game_group_id_temp: ele.game_group_id == 12 || ele.game_group_id == 8 ? 1 : ele.game_group_id };
            })
        };
    };

    componentDidUpdate(prevProps) {
        if (this.props.OrderData !== prevProps.OrderData) {
            this.LoadTransactionData()
        }
    }

    LoadTransactionData = () => {
        if (this.props.OrderData && this.props.OrderData.result && this.props.OrderData.result.length > 0) {
            let ldt = this.props.OrderData.result.filter(filterData => {
                return this.state.allStatus == 0 || filterData.game_group_id == this.state.rdoStatus || filterData.game_group_id == this.state.rdoStatus1 || filterData.game_group_id == this.state.rdoStatus2 || (filterData.game_group_id == this.state.rdoStatus3) || filterData.game_group_id == this.state.rdoStatus4 || filterData.game_group_id == this.state.rdoStatus5
                    || filterData.game_group_id == this.state.rdoStatus6 || (filterData.game_group_id == this.state.rdoStatus7 || (this.state.rdoStatus7 == 7 && filterData.game_group_id == 8))
            });
            this.setState({ lfilterdt: ldt });
            let ltotpage = Math.trunc(ldt.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(ldt.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }

    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }

    handleCallback = (start, end) => {
        if (start && end) {
            this.setState(
                {
                    startDate: start.format('DD/MM/YYYY'),
                    endDate: end.format('DD/MM/YYYY'),
                },
                () => {
                    this.onchangeNewDate(this.state.startDate, this.state.endDate);
                }
            );
        }
    };


    componentDidMount() {
        window.documentReadyjQueryFlex();
        this.handleCallback(this.state.startDate, this.state.endDate)
    }

    onchangeNewDate = (fdate, tdate) => {
        try {
            let now = new Date();
            let time = now.toTimeString().split(" ")[0];
            let [day, month, year] = tdate.split("/");
            let date2 = new Date(year + "-" + month + "-" + day + "  " + time);
            tdate = date2.getTime();

            let [day1, month1, year1] = fdate.split("/");
            let date = new Date(year1 + "-" + month1 + "-" + day1 + " " + time);
            fdate = date.getTime();
            let loginname = "ggmcptlmt_gigco"
            let starttime = fdate;
            let endtime = tdate;
            let message = "endTimepoint=" + endtime + "&login=" + loginname + "&startTimepoint=" + starttime + "";
            let secretKey = "ZyaDOd715iZ1VfEL";
            var hash = CryptoJS.MD5(message + secretKey);
            var hashHex = hash.toString(CryptoJS.enc.Hex);
            let url = "https://api.prerelease-env.biz/IntegrationService/v3/JackpotFeeds/extended/winners?login=ggmcptlmt_gigco" + "&hash=" + hashHex + "&startTimepoint=" + starttime + "&endTimepoint=" + endtime
            fetch(url).then(response => {
                response.text().then(data => {
                    if (!response.ok) {
                        const error = { message: response.statusText };
                        //return Promise.reject(error);
                    }
                    let text = JSON.parse(data);
                    if (text && text.winners && text.winners.length > 0) {
                        this.setState({ TransactionData: text.winners })
                    }
                    else {
                        this.setState({ TransactionData: [] })
                    }
                });
            });
        } catch (error) {
            this.setState({ TransactionData: [] })
        }
    }





    ConvertTimestdate = (timestamp) => {
        timestamp = new Date(timestamp);
        timestamp = timestamp.toISOString()
        return timestamp.replace("T", " ").replace("Z", "")
    }


    showMsg = (lstrError) => {
        this.props.alertError(this.props.t(lstrError));
    }
    reSetFilter = () => {
        this.setState({ rdoStatus: 0 });
    }
    render() {
        const { t } = this.props;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Order</title>
                        <meta name="description" content="Gulf Ticket Order" />
                    </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-profile.png" />{t('lbljacpotwinner')}</h1>
                </div>

                <div class="orders">
                    <div class="filters">
                        <div class="filtersCont">
                            <span>
                                <label>{t('lblsearchdate')}</label>
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: this.state.startDate,
                                        endDate: this.state.endDate,
                                        locale: {
                                            format: 'DD/MM/YYYY',
                                            separator: ' - ',
                                            applyLabel: 'Apply',
                                            cancelLabel: 'Cancel',
                                        },
                                    }} onCallback={this.handleCallback}
                                >
                                    <input id='datepicker1' value={`${this.state.startDate} - ${this.state.endDate}`} readOnly />
                                </DateRangePicker>

                            </span>
                        </div>
                        {/* <div class="filtersBtn">
                            <a >Apply</a>
                            <a ><img src="./assets/img/icons/refresh.png" /></a>
                        </div> */}

                        <div className="accHeadCont">
                            <div className="radioInputs">
                            </div>
                        </div>
                    </div>
                    <div class="table margin-top-20">
                        {this.state.TransactionData && this.state.TransactionData.length > 0 &&
                            <>
                                <ul class="transTble">
                                    <li>
                                        <div class="w-25">{t('lblplayerid')}</div>
                                        <div class="w-25">{t('lblprize')}</div>
                                        <div class="w-25">{t('lblWin')}&nbsp; {t('lbldate')}</div>
                                        <div class="w-25">{t('lblcurrency')}</div>
                                    </li>
                                    {this.state.TransactionData && this.state.TransactionData.length > 0 && this.state.TransactionData.map((data, index) =>
                                        <li key={`bk_${index}`}>
                                            <div class="w-25">{data.playSessionID}</div>
                                            <div class="w-25">{data.winAmount}</div>
                                            <div class="w-25">{this.ConvertTimestdate(data.winDate)}</div>
                                            <div class="w-25">{data.currency}</div>
                                        </li>
                                    )
                                    }
                                </ul>
                                {/* <div class="pagination">
                                    <div class="paginationLft">
                                        Showing <span>1</span> to <span>{this.state.totalPage}</span> of <span>{this.state.OrderData.length}</span> entries
                                    </div>
                                    <div class="paginationLRht">
                                        <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                        <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                    </div>
                                </div> */}
                            </>
                        }
                    </div>

                </div >

                {/* {(!this.state.OrderData || this.state.OrderData.length == 0) && <div class="noOrders">
                    <img src="./assets/img/icons/sad.png" />
                    <h3>No Orders</h3>
                    <p class="margin-bottom-20">Your order list is currently empty.</p>
                    <div class="formCont updateBtn">
                        <button onClick={() => { history.push("/") }}>Buy Now</button>
                    </div>
                </div>} */}
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { OrderData } = state.accountReducer;
    return { user, appvariables, OrderData };
}
const mapActionToProps = {
    alertError: alertActions.error,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(JackpotWinner))